import React, { useState, useEffect } from 'react';
import DataContext from './DataContext';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../constants';

const DataProvider = ({ children }) => {
    const [projects, setProjects] = useState([]);
    const [people, setPeople] = useState({});
    const [papers, setPapers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { i18n } = useTranslation();

    useEffect(() => {
        Promise.all([
            fetch(`${BASE_URL}projects/?lang=${i18n.language}`)
                .then(response => response.json()),
            fetch(`${BASE_URL}people/?lang=${i18n.language}`)
                .then(response => response.json()),
            fetch(`${BASE_URL}papers/?lang=${i18n.language}`)
                .then(response => response.json()),
            fetch(`${BASE_URL}groups/?lang=${i18n.language}`)
                .then(response => response.json())
        ]).then(([projectData, peopleData, papersData, groupsData]) => {
            setProjects(projectData);
            setPeople(peopleData);
            setPapers(papersData);
            setGroups(groupsData);
            setIsLoading(false);
        });
    }, [i18n.language]);

    return (
        <DataContext.Provider value={{ projects, people, papers, groups, isLoading }}>
            {children}
        </DataContext.Provider>
    );
};

export default DataProvider;
